import LayerAdminService from "./LayerAdminService";

export default class OsPoiService extends LayerAdminService {
  private _lbBaseUrl = process.env.REACT_APP_LB_URL;

  public async StartOsPoiImport(file: File, description: string): Promise<any> {
    const formData = new FormData();
    formData.append("osPoiArchive", file);
    formData.append("importDescription", description);

    return this._client
      .post<any>(`${this._endpoint}/Os:Poi`, formData, {
        timeout: 0,
        baseURL: this._lbBaseUrl,
      })
      .then((response) => {
        return response.data;
      });
  }
}
